import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark.js";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";



export function GraficoCustoAnual(props) {
    const cores = [am4core.color("#00d7fd"), am4core.color("#3b3bff"), am4core.color("#84f3ff"), am4core.color("#0dcf9f"), am4core.color("#0effc3")];
    const [graficoCustoAnual, setGraficoCustoAnual] = useState(null);

    function montarGraficoClusteredColumnAnual(component, nome, dados = [], titulo, prefixo, sufixo, cores) {
        if (component) {
            component.dispose();
        }

        let chart = am4core.create(nome, am4charts.XYChart3D);
        chart.colors.step = 2;

        if (cores) {
            chart.colors.list = cores;
        }

        chart.language.locale = locale;

        let title = chart.titles.create();
        title.text = titulo;
        title.fontSize = 16;
        title.marginBottom = 30;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "Gráfico";
        chart.exporting.menu.align = "right";
        chart.exporting.menu.verticalAlign = "top";
        chart.exporting.menu.items = [
            {
                label: "...",
                menu: [
                    {
                        type: "png",
                        label: "PNG",
                    },
                ],
            },
        ];

        // chart.legend = new am4charts.Legend()
        // chart.legend.position = 'top'
        // chart.legend.paddingBottom = 20
        // chart.legend.labels.template.maxWidth = 95
        chart.language.locale["_decimalSeparator"] = ",";
        chart.language.locale["_thousandSeparator"] = ".";
        chart.numberFormatter.numberFormat = "###,###,###,###.00";

        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = "category";
        xAxis.renderer.cellStartLocation = 0.1;
        xAxis.renderer.cellEndLocation = 0.9;
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.labels.template.wrap = true;
        xAxis.renderer.labels.template.maxWidth = 200;

        var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;
        yAxis.extraMax = 0.2; // 20% extra acima

        let arrangeColumns = () => {
            var series = chart.series.getIndex(0);

            var w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
            if (series.dataItems.length > 1) {
                var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
                var delta = ((x1 - x0) / chart.series.length) * w;
                if (am4core.isNumber(delta)) {
                    var middle = chart.series.length / 2;

                    var newIndex = 0;
                    chart.series.each(function (series) {
                        if (!series.isHidden && !series.isHiding) {
                            series.dummyData = newIndex;
                            newIndex++;
                        } else {
                            series.dummyData = chart.series.indexOf(series);
                        }
                    });
                    var visibleCount = newIndex;
                    var newMiddle = visibleCount / 2;

                    chart.series.each(function (series) {
                        var trueIndex = chart.series.indexOf(series);
                        var newIndex = series.dummyData;

                        var dx = (newIndex - trueIndex + middle - newMiddle) * delta;

                        series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                        series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    });
                }
            }
        };

        let createSeries = (value, name) => {
            var series = chart.series.push(new am4charts.ColumnSeries3D());
            series.dataFields.valueY = value;
            series.dataFields.categoryX = "category";
            series.name = name;

            series.events.on("hidden", arrangeColumns);
            series.events.on("shown", arrangeColumns);

            var bullet = series.bullets.push(new am4charts.LabelBullet());
            bullet.interactionsEnabled = false;
            bullet.dy = 2;
            bullet.label.text = "{valueY}";
            bullet.label.fill = am4core.color("#ffffff");
            bullet.label.truncate = false;
            // bullet.label.hideOversized = true;

            series.columns.template.tooltipText = `{categoryX}: [bold]${prefixo} {valueY.formatNumber("###,###,###,###.00")} ${sufixo}[/]`;
            series.columns.template.fillOpacity = 0.8;

            // Dentro de createSeries
            series.columns.template.adapter.add("fill", function (fill, target) {
                if (target.dataItem && target.dataItem.dataContext.color) {
                    return target.dataItem.dataContext.color;
                }
                return fill;
            });

            return series;
        };

        let data = [];
        dados.forEach((item) => {
            item.anos.forEach((itemAno) => {
                if (data.filter((serie) => serie.category == itemAno.ano).length == 0) {
                    data.push({
                        category: String(itemAno.ano),
                        value: 0,
                    });
                }
                data = data.map((serie) => {
                    if (serie.category == itemAno.ano) {
                        return {
                            ...serie,
                            value: serie.value + (itemAno.valor == "NaN" ? 0 : itemAno.valor),
                        };
                    } else {
                        return serie;
                    }
                });
            });
        });

        data.sort((a, b) => {
            return a.category == "Início" ? -1 : b.category == "Início" ? 1 : a.category < b.category ? -1 : 1;
        });

        // Define cor diferente para a última coluna
        if (data.length > 0) {
            data[data.length - 1].color = am4core.color("#FF4081"); // rosa vibrante, por exemplo
        }

        chart.data = data;

        createSeries("value", "");

        return chart;
    }

    useEffect(() => {
        const graficoCustoAnualAtualizado = montarGraficoClusteredColumnAnual(
            graficoCustoAnual,
            "graficoCustoAnual",
            props.listaGraficoCustoAnual,
            "Custo Geral Acumulado Anual (R$)",
            "R$",
            "",
            cores
        );
        if (!graficoCustoAnual) {
            setGraficoCustoAnual(graficoCustoAnualAtualizado);
        }
        return () => {
            if (graficoCustoAnual) graficoCustoAnual.dispose();
        };
    });

    am4core.useTheme(am4themes_dark);

    return (
        <ContentCard style={{ backgroundColor: "#30303d", color: "#fff", paddingBlock: 15 }}>
            <ContentCardBody padding="0" style={{ height: 512 }}>
                <div id="graficoCustoAnual" style={{ width: "100%", height: 500 }}></div>
            </ContentCardBody>
        </ContentCard>
    );
}
